import { BarChart as ReBarChart, Bar, Tooltip, ResponsiveContainer, YAxis, XAxis, CartesianGrid } from "recharts"

export default function BarChart({ data,
  width = "100%",
  height = 300,
  fillColor,
  secFillColor = "#32383F",
  dataKey1 = "uv",
  dataKey2 = "pv",
  yaxis = false,
  domain,
  ticks
}) {

  return (
    <ResponsiveContainer width={width} height={height}>
      <ReBarChart
        data={data}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <XAxis dataKey="name" />
        {yaxis &&
          <YAxis
            domain={domain}
            ticks={ticks}
            tickFormatter={(value) => `${value}`}
            axisLine={false}
            tickLine={false}
          />
        }
        <Tooltip />
        <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
        <Bar
          dataKey={dataKey1}
          radius={[3, 3, 3, 3]}
          // background={{ fill: "#32383F", radius: ["3", "3", "3", "3"] }}
          fill={fillColor}
        // label={{ position: 'top', fill: '#000', fontSize: 12 }}
        />
        <Bar
          dataKey={dataKey2}
          radius={[3, 3, 3, 3]}
          // background={{ fill: "#32383F", radius: ["3", "3", "3", "3"] }}
          fill={secFillColor}
        // label={{ position: 'top', fill: '#000', fontSize: 12 }}
        />
      </ReBarChart>
    </ResponsiveContainer>
  )
}
